import { TextInputValidationFn } from '@Shared/Components/Inputs/TextInput/TextInput'

export const EmailRegexValidation = email => email.match(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
)

export const EmailValidationV2: TextInputValidationFn = (email) => {
  if (EmailRegexValidation(email)) {
    return { success: true, errorMessage: '' }
  }
  return {
    errorMessage: 'common:COF_YOUR_EMAIL_IS_INVALID',
    success: false,
  }
}
